var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgSearchBorderlessPink(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    stroke: "#e1087e"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M26.56 25.94l-4.2-4.2a8.253 8.253 0 002.14-5.55c0-4.59-3.72-8.31-8.31-8.31s-8.31 3.72-8.31 8.31 3.72 8.31 8.31 8.31c2.14 0 4.08-.81 5.55-2.14l4.2 4.2.62-.62zm-10.37-2.32c-4.1 0-7.44-3.34-7.44-7.44s3.34-7.44 7.44-7.44 7.44 3.34 7.44 7.44-3.34 7.44-7.44 7.44z",
    "data-name": "Header - Opt 1 (Grey)",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })));
}
export default SvgSearchBorderlessPink;